module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-light-gray@2x-f111a8f767dad8596222b0dd9820d8ef.png";